import { defineStore } from 'pinia';
import { RequestMethod, RequestName, RequestProxy, useCaller } from '~/hydration/bridges';

export const useAddressesStore = defineStore('addresses', {
  state: (): {} => {
    return {};
  },
  actions: {
    async searchPlaces(searchKeyword: string, scanAllCountries = 0) {
      const { result } = await useCaller(
        RequestProxy.NEURON_API,
        RequestName.FETCH_PLACES,
        'addresses/places',
        RequestMethod.GET,
        {
          search_keyword: searchKeyword,
          scan_all_countries: !!scanAllCountries,
        },
      );

      return result;
    },

    async getGeocodeByPlaceId(placeId: string) {
      const { result } = await useCaller(
        RequestProxy.NEURON_API,
        RequestName.GET_GEOCODE_BY_PLACE_ID,
        'addresses/geocodes',
        RequestMethod.GET,
        {
          place_id: placeId,
        },
      );

      return result;
    },

    async getGeocodeByFullAddress(fullAddress: string) {
      const { result } = await useCaller(
        RequestProxy.NEURON_API,
        RequestName.GET_GEOCODE_BY_FULL_ADDRESS,
        'addresses/geocodes',
        RequestMethod.GET,
        {
          full_address: fullAddress,
        },
      );

      return result;
    },

    async getAddressesByPostcode(postcode: string) {
      const { result } = await useCaller(
        RequestProxy.NEURON_API,
        RequestName.GET_ADDRESSES_BY_POSTCODE,
        'addresses/postcodes',
        RequestMethod.GET,
        {
          postcode,
        },
      );

      return result;
    },

    async getGeocodeByLatLong(lat: number, lng: number) {
      const { result } = await useCaller(
        RequestProxy.NEURON_API,
        RequestName.GET_GEOCODE_BY_LAT_AND_LNG,
        'addresses/geocodes',
        RequestMethod.GET,
        {
          lat,
          lng,
        },
      );

      return result;
    },
  },
  getters: {},
});
